/**
 * Filters product media gallery by image alt text when variant changes.
 * Show images where alt is empty, equals product title, or matches selected option (e.g. "White").
 * Runs client-side for instant updates when color/variant is selected.
 * Requires: pubsub.js, constants.js (for PUB_SUB_EVENTS)
 */
(function () {
  function shouldShowMedia(alt, productTitle, selectedValue) {
    const altTrimmed = (alt || '').trim();
    const titleTrimmed = (productTitle || '').trim();
    const valueTrimmed = (selectedValue || '').trim().toLowerCase();
    if (altTrimmed === '') return true;
    if (altTrimmed === titleTrimmed) return true;
    if (valueTrimmed && altTrimmed.toLowerCase() === valueTrimmed) return true;
    return false;
  }

  function filterGallery(productInfo, variant) {
    if (!productInfo?.dataset?.filterMediaByAlt) return;

    const productTitle = productInfo.dataset.productTitle || '';
    const colorIndex = parseInt(productInfo.dataset.colorOptionIndex, 10);
    if (isNaN(colorIndex) || colorIndex < 0) return;

    const selectedValue = variant?.[`option${colorIndex + 1}`] || '';

    const mediaSlides = productInfo.querySelectorAll('media-gallery ul[role="list"] li[data-media-alt]');
    const thumbnails = productInfo.querySelectorAll('.thumbnail-list__item[data-media-alt]');
    const modalItems = document.querySelectorAll(`#ProductModal-${productInfo.dataset.section} .product-media-modal__item[data-media-alt]`);

    let firstVisibleMediaId = null;

    mediaSlides.forEach((slide) => {
      const alt = slide.dataset.mediaAlt || '';
      const show = shouldShowMedia(alt, productTitle, selectedValue);
      slide.classList.toggle('variant-gallery-hidden', !show);
      if (show && !firstVisibleMediaId) {
        firstVisibleMediaId = slide.dataset.mediaId;
        slide.classList.add('is-active');
      } else {
        slide.classList.remove('is-active');
      }
    });

    thumbnails.forEach((thumb) => {
      const alt = thumb.dataset.mediaAlt || '';
      const show = shouldShowMedia(alt, productTitle, selectedValue);
      thumb.classList.toggle('variant-gallery-hidden', !show);
      const btn = thumb.querySelector('button');
      const isActive = show && thumb.dataset.target === firstVisibleMediaId;
      if (btn) btn.setAttribute('aria-current', isActive ? 'true' : 'false');
    });

    modalItems.forEach((item) => {
      const alt = item.dataset.mediaAlt || '';
      const show = shouldShowMedia(alt, productTitle, selectedValue);
      item.classList.toggle('variant-gallery-hidden', !show);
    });

    if (firstVisibleMediaId) {
      const mediaGallery = productInfo.querySelector('media-gallery');
      if (mediaGallery?.setActiveMedia) {
        mediaGallery.setActiveMedia(firstVisibleMediaId, true);
      }
    }
  }

  function init() {
    try {
      if (typeof subscribe !== 'function') return;
      const variantChangeEvent = (typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS?.variantChange) || 'variant-change';
      subscribe(variantChangeEvent, (event) => {
      const { variant } = event?.data || {};
      const productInfo = document.querySelector('product-info[data-filter-media-by-alt]');
      if (productInfo && variant) {
        filterGallery(productInfo, variant);
      }
    });
    } catch (e) {
      console.warn('variant-gallery-filter: init failed', e);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
